import * as React from 'react';
import { createPortal } from 'react-dom';

import MixedSelectDropdownMenu from '../menu/MixedSelectDropdownMenu';

import './mixed-select-dropdown-menu-container.scss';

import type { MixedSelectDropdownItem } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  items: Array<MixedSelectDropdownItem>,
  withMulti?: boolean,
  withCheckboxes?: boolean,
  withColors?: boolean,
  withIcons?: boolean,
  withTruncate?: boolean,
  withSelectAll?: boolean,
  withSelectedInList?: boolean,
  withSmallSize?: boolean,
  withTags?: boolean,
  inputValue?: string,
  controlRef: React.RefObject<any>,
  isMenuOpen: boolean,
  menuClassName?: string,
  menuItemClassName?: string,
  onItemToggle: (b: string, a: boolean) => void,
  onItemsToggle: (b: string, a: boolean) => void,
  onItemsToggleAll: () => void,
  onMouseEnterMenu: () => void,
  onMouseLeaveMenu: () => void
};

class MixedSelectDropdownMenuContainer extends React.PureComponent<Props> {
  menuContainer: HTMLElement = document.createElement('div');

  componentDidMount() {
    if (document.body && !document.body.contains(this.menuContainer)) {
      document.body.appendChild(this.menuContainer);
    }
  }

  componentWillUnmount() {
    if (document.body && document.body.contains(this.menuContainer)) {
      document.body.removeChild(this.menuContainer);
    }
  }

  handleItemsToggle = (event: SyntheticEvent<HTMLElement>): void => {
    const { withMulti, onItemToggle, onItemsToggle } = this.props;
    const target = event.currentTarget;
    const identifier = target.dataset.identifier;
    const checked = target.dataset.checked === 'true';

    if (identifier === undefined) {
      return;
    }

    if (withMulti) {
      onItemsToggle(identifier, !checked);
      return;
    }

    onItemToggle(identifier, !checked);
  };

  renderMenu(): React.ReactNode {
    const {
      items,
      inputValue,
      withMulti,
      withCheckboxes,
      withColors,
      withIcons,
      withTruncate,
      withSelectAll,
      withSelectedInList,
      withSmallSize,
      withTags,
      controlRef,
      menuClassName,
      menuItemClassName,
      onItemsToggleAll,
      onMouseEnterMenu,
      onMouseLeaveMenu
    } = this.props;

    return createPortal(
      <MixedSelectDropdownMenu
        items={items}
        inputValue={inputValue}
        withMulti={withMulti}
        withCheckboxes={withCheckboxes}
        withColors={withColors}
        withIcons={withIcons}
        withTruncate={withTruncate}
        withSelectAll={withSelectAll}
        withSelectedInList={withSelectedInList}
        withSmallSize={withSmallSize}
        withTags={withTags}
        controlRef={controlRef}
        menuClassName={menuClassName}
        menuItemClassName={menuItemClassName}
        onItemsToggle={this.handleItemsToggle}
        onItemsToggleAll={onItemsToggleAll}
        onMouseEnterMenu={onMouseEnterMenu}
        onMouseLeaveMenu={onMouseLeaveMenu}
      />,
      this.menuContainer
    );
  }

  render(): React.ReactNode {
    const { isMenuOpen } = this.props;

    return (
      <div className="mixed-select-dropdown-menu-container">
        {
          isMenuOpen &&
            this.renderMenu()
        }
      </div>
    );
  }
}

export default MixedSelectDropdownMenuContainer;
